<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="title"
    :type-modal="typeModal"
  >
    <div class="modal-content__main">
      <d-form @submit.prevent="emitSave">
        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feName">Nome</label>

            <d-form-input
              v-if="model.id"
              type="text"
              v-model="model.name"
              id="feName"
              placeholder="Nome"
            />

            <autocomplete
              v-else
              ref="autocomplete"
              placeholder="Equipamento"
              :items="equipmentsList"
              item-show="name"
              :on-input="onInput"
              :on-select="setEquipment"
              :on-blur="setEquipmentBlur"
              :on-show-text="showText"
            />
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <template #actions>
      <d-button type="button" class="btn btn-sm btn-secondary mr-4" @click="cancel">
        Cancelar
      </d-button>
      <d-button type="button" class="btn btn-sm btn-primary" @click="emitSave">
        Salvar
      </d-button>
    </template>
  </modal-template>
</template>

<script>
import { stringfy, capitalize } from '_utils';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import ModalTemplate from '_shared/Modal.vue';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';

export default {
  name: 'AddEquipmentModal',
  components: { Autocomplete, ModalTemplate },
  props: {
    title: { type: String, default: 'Adicionar novo Equipamento' },
    typeModal: { type: String, default: 'add_equipment_modal' },
    loadEvent: { type: String, required: true },
    saveEvent: { type: String, required: true },
    reloadEvent: { type: String, required: true },
    searchEvent: { type: String, required: true },
    equipmentsList: { type: Array, default: () => [] },
  },
  data() {
    return {
      entityId: null,
      model: { ...EQUIPMENT_DEFAULT },
      searchTimeoutId: null,
    };
  },
  methods: {
    cancel() {
      this.$store.dispatch('setToggle', { type: this.typeModal, bool: false });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        Events.$emit(this.searchEvent, name || '');
      }, 400);
    },
    emitSave() {
      const payload = {
        ...this.model,
        name: capitalize(this.model.name || ''),
        slug: stringfy(this.model.name || ''),
      };
      Events.$emit(this.saveEvent, { entityId: this.entityId, model: payload });
    },
    setEquipment(equipment) {
      this.model = equipment;
    },
    setEquipmentBlur(value) {
      if (!this.model.id) this.model.name = value;
    },
    showText(item) {
      return `<strong>${item.id}</strong> ${item.name}`;
    },
    handleLoad({ id, option }) {
      this.entityId = id;
      this.model = option ? { ...option } : { ...EQUIPMENT_DEFAULT };
    },
  },
  mounted() {
    Events.$on(this.loadEvent, this.handleLoad);
  },
  beforeDestroy() {
    Events.$off(this.loadEvent, this.handleLoad);
  },
};
</script>
